export default __webpack_public_path__ + "static/media/blush-hot-spring.84fc397b.png";